<div class="common-table-style">
    <div class="header-box">
        <div class="d-flex align-items-center heading-box">
            <ng-icon name="heroUser"></ng-icon>
            <h2>Account Master</h2>
        </div>
        <div class="d-flex justify-content-between flex-wrap align-items-center col-md-9 p-0">
            <div class="dense-4 search-and-filter">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Search</mat-label>
                    <input matInput [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()"
                        placeholder="Search accounts...">
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
            </div>
            <div class="dense-4 search-and-filter">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Filter by Status</mat-label>
                    <mat-select [(ngModel)]="selectedStatus" (ngModelChange)="onStatusChange()">
                        <mat-option value="all">All</mat-option>
                        <mat-option value="DRAFT">Draft</mat-option>
                        <mat-option value="ACTIVE">Active</mat-option>
                        <mat-option value="INACTIVE">Inactive</mat-option>
                        <mat-option value="BLACKLISTED">Blacklisted</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <button color="accent" mat-raised-button (click)="addAccount()">
                Add Account
            </button>
        </div>
    </div>


    <div class="inner-box">

        <mat-table [dataSource]="getPaginatedData()">

            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef>
                    <div class="sortable-header" (click)="onSortChange('name')">
                        Account Name
                        <mat-icon class="sort-icon">{{ getSortIcon('name') }}</mat-icon>
                    </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let account">
                    <span class="account-name">{{ account.name }}</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="id">
                <mat-header-cell *matHeaderCellDef>
                    <div class="sortable-header" (click)="onSortChange('id')">
                        Account ID
                        <mat-icon class="sort-icon">{{ getSortIcon('id') }}</mat-icon>
                    </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let account">{{ account.id || '-' }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="createdBy">
                <mat-header-cell *matHeaderCellDef>
                    <div class="sortable-header" (click)="onSortChange('createdBy')">
                        Created By
                        <mat-icon class="sort-icon">{{ getSortIcon('createdBy') }}</mat-icon>
                    </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let account">{{ getUserName(account.createdBy) }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="createdAt">
                <mat-header-cell *matHeaderCellDef>
                    <div class="sortable-header" (click)="onSortChange('createdAt')">
                        Created Date
                        <mat-icon class="sort-icon">{{ getSortIcon('createdAt') }}</mat-icon>
                    </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let account">{{ formatDateOnly(account.createdAt) }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="updatedAt">
                <mat-header-cell *matHeaderCellDef>
                    <div class="sortable-header" (click)="onSortChange('updatedAt')">
                        Last Updated
                        <mat-icon class="sort-icon">{{ getSortIcon('updatedAt') }}</mat-icon>
                    </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let account">{{ formatDate(account.updatedAt) }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef>
                    <div class="sortable-header" (click)="onSortChange('status')">
                        Status
                        <mat-icon class="sort-icon">{{ getSortIcon('status') }}</mat-icon>
                    </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let account">
                    <span *ngIf="account.status" class="status-badge"
                        [ngClass]="'status-' + getStatusColor(account.status)">
                        {{ getStatusLabel(account.status) }}
                    </span>
                    <span *ngIf="!account.status" class="status-empty">-</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
                <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                <mat-cell *matCellDef="let account">
                    <button mat-icon-button matTooltip="View Account" (click)="viewAccount(account)"
                        class="action-button mr-2">
                        <mat-icon>visibility</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="Edit Account" (click)="editAccount(account)"
                        class="action-button">
                        <mat-icon>edit</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>

        <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageIndex]="pageIndex"
            [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true" (page)="onPageChange($event)">
        </mat-paginator>
    </div>
</div>